import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "./cn";

export type NativeSelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * A native `<select>` styled like {@link Input}. The app has no Radix Select;
 * forms use the browser's own control (accessible and keyboard-complete for
 * free), and this keeps its look in one place.
 */
export const NativeSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-md border border-border bg-surface px-2 py-2 text-sm text-on-surface shadow-sm transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface",
        "disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-danger",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
NativeSelect.displayName = "NativeSelect";
